// Beslissing van de route-gate (ProtectedRoute) uit de gedeelde auth/me-toestand. Puur, zodat de
// volgorde testbaar is (issue #23: wachtpagina voor wie aangemeld is maar nog geen rol heeft).
import { landingKeys, needsActivation } from "utils/landing";

// Aangemeld en door de server toegelaten, maar zonder rol. Enkel als auth/me het access-blok
// meestuurt (matrix-modus, API vanaf rechten F1): anders weten we niet of het een wachtende of
// een geweigerde gebruiker is, en blijft het oude gedrag (terug naar de login met een melding).
// Ook wie al toewijzingen heeft die in F1 nog geen rechten geven (bv. enkel een deelbereik) komt
// hier terecht: dat is geen weigering, Beheer moet de toewijzing aanvullen.
export function isWaitingForAccess({ allowed, hasRequiredRole, access } = {}) {
  return Boolean(allowed) && !hasRequiredRole && access != null && typeof access === "object";
}

// Volgorde is dragend:
//  1. pending   — auth/me loopt nog;
//  2. error     — technische fout: in-place met retry, nooit redirecten (anti-loop-teller);
//  3. waiting   — aangemeld zonder rol: wachtpagina, géén redirect naar de login (die stuurde terug);
//  4. denied    — echt serveroordeel (403 op token/tenant/rol): terug naar de login met melding;
//  5. activate  — enkel activeerbare rollen die nu niet lopen (bv. alleen Beheer): het activatiescherm;
//  6. forbidden — wel rollen, maar deze pagina hoort er niet bij (de gate stuurt door naar de eerste toegelaten pagina);
//  7. landing   — het Overzicht zonder actieve bedrijfsrol (bv. enkel Beheer): door naar de eerste zinvolle pagina;
//  8. ok.
export function authGateDecision(info = {}, routeKey = null) {
  const { loading, error, denied, allowed, hasRequiredRole, pages } = info;
  if (loading) return "pending";
  if (error) return "error";
  if (info.waiting ?? isWaitingForAccess(info)) return "waiting";
  if (denied || !allowed || !hasRequiredRole) return "denied";
  if (needsActivation(info)) return "activate";
  if (routeKey && Array.isArray(pages) && pages.length > 0 && !pages.includes(routeKey)) return "forbidden";
  // Issue #23 (landing): het Overzicht toont enkel bedrijfsdata; zonder actieve bedrijfsrol gaf het 403 → "Geen toegang".
  if (routeKey === "home" && Array.isArray(info.access?.roles) && info.access.roles.length > 0 && !landingKeys(info).includes("home"))
    return "landing";
  return "ok";
}
